import settingConverter from 'models/Setting/converter'
import getRootDoc from 'actions/base/getRootDoc'

const getCollection = (withConverter = true) => getRootDoc(withConverter ? settingConverter : null)

export default getCollection
